import { Button, Dolphin } from '@podiumhq/podium-ui';
import { logout } from '@podiumhq/foe-hammer';
import styled from 'styled-components';
import env from '../../lib/env';

const Main = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  opacity: 0.94;
  background-color: #262626;
  padding-top: 50px;
`;

const Title = styled.div`
  width: 431px;
  height: 28px;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  line-height: 28px;
  color: #ffffff;
  margin: 0 auto;
  margin-top: 20px;
`;

const Message = styled.div`
  width: 35rem;
  text-align: center;
  line-height: 1.375em;
  color: #ffffff;
  margin-bottom: 2px;
  margin-top: 20px;
  margin: 0 auto;
  padding-top: 10px;
  font-size: 15px;
  font-weight: 400;
`;

const Icon = styled(Dolphin)`
  width: 100%;
  height: 119px;
  margin: 0 auto;
  opacity: 1;
`;

const TryAgainWrapper = styled.div`
  margin-top: 1.75em;
  text-align: center;
`;

function NoAccess() {
  return (
    <Main>
      <Icon emotion="concerned" />
      <Title>Ahhh nuts</Title>
      <Message>It looks like you don&rsquo;t have access to this app.</Message>
      <TryAgainWrapper>
        <Button onClick={() => logout(env.REACT_APP_ACCOUNT_URL || '')}>
          Try again
        </Button>
      </TryAgainWrapper>
    </Main>
  );
}

export default NoAccess;
